import React, { Component } from 'react';
import {CardElement} from 'react-stripe-elements';

import {injectStripe} from 'react-stripe-elements';

class StripeCard extends Component {
  getStripe(){
    return this.props.stripe;
  }
  handleSubmit(e){
    e.preventDefault();
    this.props.stripe.createToken().then(t=>console.log('token', t));
  }
  render(){
    return (
      <form className="form-horizontal" onSubmit={this.handleSubmit.bind(this)}>
        <div className="form-group">
          <label className="col-sm-3 control-label">Card details</label>
          <div className="col-sm-9">
            <CardElement hidePostalCode={true}
              className="form-control"
              style={{base: {fontSize: '18px'}}} />
          </div>
        </div>
      </form>
    );
  }
}

export default injectStripe(StripeCard);



// WEBPACK FOOTER //
// ./src/pages/components/StripeCard.js